import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSouthEast = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 19C9.71667 19 9.47934 18.904 9.288 18.712C9.096 18.5207 9 18.2834 9 18C9 17.7167 9.096 17.4794 9.288 17.288C9.47934 17.096 9.71667 17 10 17H15.6L4.7 6.10005C4.51667 5.91672 4.425 5.68338 4.425 5.40005C4.425 5.11672 4.51667 4.88338 4.7 4.70005C4.88334 4.51672 5.11667 4.42505 5.4 4.42505C5.68334 4.42505 5.91667 4.51672 6.1 4.70005L17 15.6V10C17 9.71672 17.096 9.47905 17.288 9.28705C17.4793 9.09572 17.7167 9.00005 18 9.00005C18.2833 9.00005 18.5207 9.09572 18.712 9.28705C18.904 9.47905 19 9.71672 19 10V18C19 18.2834 18.904 18.5207 18.712 18.712C18.5207 18.904 18.2833 19 18 19H10Z",
		fill: "currentColor"
	})
});
export default SvgSouthEast;
